var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("template-listing-base", {
    attrs: {
      title: _vm.resource("TemplatePrimaryListing_Listing_Title"),
      "list-title": _vm.resource("TemplatePrimaryListing_Listing_ListTitle"),
      templates: _vm.templates,
      "can-search": true,
      "can-create": true
    },
    scopedSlots: _vm._u([
      {
        key: "template-listing-item",
        fn: function(ref) {
          var template = ref.template
          return [
            _c("template-primary-listing-item", {
              class: { selected: _vm.selectedTemplate === template },
              attrs: { template: template },
              on: {
                "template-selected": function($event) {
                  return _vm.$emit("template-selected", template.Id)
                },
                "template-deleted": function($event) {
                  return _vm.removeTemplate(template)
                }
              }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }